var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachinesSettingsIcon = function SvgMachinesSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.338,
    d: "M6.669 18.087c0-.11.09-.2.2-.2h18.175c.11 0 .2.09.2.2v.783a.2.2 0 0 1-.2.2h-1.275a1.08 1.08 0 0 0-1.052-.826H9.152c-.51 0-.936.352-1.051.826H6.87a.2.2 0 0 1-.201-.2zm6.956-12.956c0-.111.09-.2.201-.2H25.13c.111 0 .201.089.201.2v10.347a.2.2 0 0 1-.2.201H13.825a.2.2 0 0 1-.2-.2zm-6.956 0c0-.111.09-.2.2-.2h4.522c.111 0 .201.089.201.2v10.347a.2.2 0 0 1-.2.201H6.87a.2.2 0 0 1-.201-.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.892,
    d: "M15.758 10.953V7.118h7.492v3.835z"
  })));
};
export default SvgMachinesSettingsIcon;